import styled from 'styled-components';

import {
  Colors,
  Sizes,
} from '@noitada/shared/constants';



export interface IProps {
  color?: string
}



export const OrderSheetInfoButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: white;
  border-radius: ${Sizes.cardRadius}px;
`;



export const CardSheetContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-left: ${Sizes.paddingContainer}px;
  padding-right: ${Sizes.paddingContainer}px;
  padding-bottom: 10px;
`;


export const HeaderInfoCheckinView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CheckInfoView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 5px;
`;

export const CheckinUserRowHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CheckinUserIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 5px;
`;

export const CheckinUserTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.black};
  font-weight: 400;
`;

export const CheckinUserText = styled.p`
  color: ${Colors.black};
  font-size: 20px;
  font-weight: bold;
`;


export const OrderLimitTimeView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  align-items: flex-end;
`;

export const LimitTimeTitle = styled.p`
  color: ${Colors.primary};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: right;
`;

export const LimitTimeText = styled.p`
  color: ${(props: IProps) => props.color || Colors.primary};
  font-size: 22px;
  font-weight: bold;
  text-align: right;
`;



export const HeaderInfoPreparView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
`;

export const TotalItemsPreparView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const OrderPreparTitle = styled.p`
  color: ${Colors.black};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export const OrderLartTimeText = styled.p`
  color: black;
  font-size: 16px;
  font-weight: bold;
`;

export const TotalItemsPreparText = styled.p`
  margin-top: 5px;
  color: ${Colors.sketch};
  font-size: 18px;
  font-weight: bold;
  text-align: right;
`;



export const CompleteHistoryButton = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 8px;
  background-color: ${Colors.buttonOk};
  border-bottom-left-radius: ${Sizes.cardRadius}px;
  border-bottom-right-radius: ${Sizes.cardRadius}px;
`;

export const HistoryText = styled.p`
  color: ${Colors.white};
  font-size: 20px;
  line-height: 30px;
`;
